import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SupportForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/support`, formData);
      toast.success('Mensaje enviado exitosamente');
      navigate(user.role === 'admin' ? '/' : '/');
    } catch (error) {
      console.error('Error sending support message:', error);
      toast.error('Error al enviar el mensaje');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Centro de Ayuda</h1>
        <Link to="/" className="btn-back">
          ← Volver
        </Link>
      </div>

      <div className="support-form-container">
        <div className="support-info">
          <h2>¿Necesitas ayuda?</h2>
          <p>
            Completa el formulario a continuación y nuestro equipo de soporte
            te ayudará lo antes posible.
          </p>
          <div className="info-cards">
            <div className="info-card">
              <span className="info-icon">💬</span>
              <h3>Respuesta Rápida</h3>
              <p>Responderemos en menos de 24 horas</p>
            </div>
            <div className="info-card">
              <span className="info-icon">🔒</span>
              <h3>Información Segura</h3>
              <p>Tus datos están protegidos</p>
            </div>
          </div>
        </div>

        <form className="support-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nombre Completo *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Tu nombre"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email de Contacto *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="[email protected]"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Asunto *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="¿En qué podemos ayudarte?"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Mensaje *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="6"
              placeholder="Describe tu problema o pregunta en detalle..."
            />
          </div>

          <button
            type="submit"
            className="btn-submit"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Mensaje'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupportForm;
